import React from 'react';
import PropTypes from 'prop-types';
import { TooltipDivider, TooltipOptionList } from '@luigiclaudio/ga-baseline-ui/tooltip';
import ColorTooltipOptionValue from '../colorTooltipOptions/ColorTooltipOptionValue';
import ColorTooltipOptionDetails from '../colorTooltipOptions/ColorTooltipOptionDetails';
import ColorTooltipOptionSetMainColor from '../colorTooltipOptions/ColorTooltipOptionSetMainColor';
import ColorTooltipOptionFavorite from '../colorTooltipOptions/ColorTooltipOptionFavorite';

const ColorVariantFooterTooltipOptions = ({ colorValue, hideTooltip, showAddToFavorites }) => {
    return (
        <TooltipOptionList>
            <ColorTooltipOptionValue colorValue={colorValue} hideTooltip={hideTooltip} />
            <TooltipDivider as="li" />
            <ColorTooltipOptionDetails
                colorValue={colorValue}
                hideTooltip={hideTooltip}
                modalProps={{ showSetAsMain: true, showAddRemoveFromLibrary: true }}
            />
            <ColorTooltipOptionSetMainColor colorValue={colorValue} hideTooltip={hideTooltip} />
            <ColorTooltipOptionFavorite
                colorValue={colorValue}
                hideTooltip={hideTooltip}
                showAddToFavorites={showAddToFavorites}
            />
        </TooltipOptionList>
    );
};

ColorVariantFooterTooltipOptions.propTypes = {
    colorValue: PropTypes.string,
    hideTooltip: PropTypes.func,
    showAddToFavorites: PropTypes.bool,
};

ColorVariantFooterTooltipOptions.defaultProps = {
    colorValue: undefined,
    hideTooltip: () => {},
    showAddToFavorites: false,
};

export default ColorVariantFooterTooltipOptions;
